import { ApolloLink, HttpLink } from "@apollo/client";
import { onError } from '@apollo/client/link/error'
import { shrinkGETQuery } from '../util/shrinkGETQuery'

const customFetchToShrinkQuery = (uri, options) => {
    let url = uri
    if (options.method === 'GET') {
      url = shrinkGETQuery(uri)
    }
    return fetch(url, options)
  }

const createBCLink = () => {
  // HTTP connection to the API
  const httpLink = new HttpLink({
    uri: '/b3graphql',
    credentials: 'same-origin',
    fetch: customFetchToShrinkQuery,
    // Warning: useGETForQueries risks exceeding URL length limits. These limits
    // in practice are typically set at or behind where TLS terminates. For Magento
    // Cloud and Fastly, 8kb is the maximum by default
    // https://docs.fastly.com/en/guides/resource-limits#request-and-response-limits
    useGETForQueries: false
  })

    // HTTP headers middleware
    const middlewareLink = new ApolloLink((operation, forward) => {
        // Support WireMock for customer headers
        const context = operation.getContext()
        operation.setContext({
          headers: {
            ...context?.headers
          }
        })

        return forward(operation)
      })

      // HTTP errors message
      const errorLink = onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
          // Global error
          graphQLErrors.forEach(({ message }, index) => {
            graphQLErrors[index].message = message.replace('GraphQL error: ', '')

            console.error(graphQLErrors[index].message)

          })
        }

        if (networkError) {
          console.error(networkError)

        }
      })

      // Merge http to middleware
      const apolloLink = middlewareLink.concat(httpLink)

      return errorLink.concat(apolloLink)

}

export default createBCLink;